import useTheme from "config/useTheme";
import styles from "./ExplorerWidgetPlayer.module.css";
import ArrowLeft from "img/explorer_widget/arrow_left_blue.svg";
import ArrowRight from "img/explorer_widget/arrow_right_blue.svg";
import DoubleArrowLeft from "img/explorer_widget/double_left.svg";
import DoubleArrowRight from "img/explorer_widget/double_right.svg";
import PauseIcon from "img/explorer_widget/pause_icon_blue.svg";
import PlayIcon from "img/explorer_widget/play_blue.svg";
import { useEffect, useState } from "react";

const ExplorerWidgetPlayer = ({
  blocks,
  setPreview,
  setPlayerPause,
  setPlayerLive,
}) => {
  const { dark } = useTheme();
  const [animation, setAnimation] = useState(false);
  const [pause, setPause] = useState(false);
  const [previewBlocks, setPreviewBlocks] = useState(
    JSON.parse(JSON.stringify(blocks))
  );
  const [currentLiveBlock, setCurrentLiveBlock] = useState(
    previewBlocks.length < 5
      ? previewBlocks[0]
      : previewBlocks[previewBlocks.length - 5]
  );

  useEffect(() => {
    if (pause) return;
    // Sveži blokovi se računaju JEDNOM i koriste za oba upisa.
    //
    // Ranije je drugi upis čitao `previewBlocks`, iako je `setPreviewBlocks`
    // pozvan red iznad — a stanje se u Reactu ne menja odmah. Prikazani blok
    // je zato bio iz PRETHODNOG osvežavanja, dakle jedan korak iza. Linter je
    // to i prijavio kao izostavljenu zavisnost.
    const sveziBlokovi = JSON.parse(JSON.stringify(blocks));
    setPreviewBlocks(sveziBlokovi);
    setCurrentLiveBlock(
      sveziBlokovi.length < 5
        ? sveziBlokovi[0]
        : sveziBlokovi[sveziBlokovi.length - 5]
    );
  }, [blocks, pause]);

  const handlePause = () => {
    if (pause) {
      setPause(false);
      setPlayerPause(false);
      setPlayerLive(true);
      setCurrentLiveBlock(previewBlocks[previewBlocks.length - 1]);
      setPreview(previewBlocks[previewBlocks.length - 1]);
    } else {
      setPause(true);
      setPlayerPause(true);
      setPlayerLive(false);
    }
  };

  const handleSetPreview = () => {
    setPreview(currentLiveBlock);
  };

  const handlePrevious = () => {
    setPause(true);
    setPlayerPause(true);
    setPlayerLive(false);

    const prevBlock = previewBlocks.find(
      (block) => block.block_num === currentLiveBlock.block_num - 1
    );
    if (prevBlock) {
      setPreview(prevBlock);
      setCurrentLiveBlock(prevBlock);
      animatePreview();
    }
  };

  const handleNext = () => {
    setPause(true);
    setPlayerPause(true);
    setPlayerLive(false);

    const nextBlock = previewBlocks.find(
      (block) => block.block_num === currentLiveBlock.block_num + 1
    );
    if (nextBlock) {
      setPreview(nextBlock);
      setCurrentLiveBlock(nextBlock);
      animatePreview();
    }
  };

  const handleLivePreview = () => {
    setPause(false);
    setPlayerPause(false);
    setPlayerLive(true);
    setCurrentLiveBlock(previewBlocks[previewBlocks.length - 1]);
    setPreview(previewBlocks[previewBlocks.length - 1]);
};


  const handleToFirstBlock = () => {
    const firstBlock = previewBlocks[0];
    if (firstBlock) {
      setPreview(firstBlock);
      setCurrentLiveBlock(firstBlock);
    }
  };

  const animatePreview = () => {
    setAnimation(true);
    setTimeout(() => {
      setAnimation(false);
    }, 400);
  };

  return (
    <div className={`${styles.component} ${dark ? styles.dark : ""}`}>
      <div className={styles.container}>
        <h5>Live</h5>
        <div
          className={`${styles.preview} ${
            animation ? styles.animate_preview : ""
          }`}
        >
          <p>{currentLiveBlock?.master}</p>
          <p>{currentLiveBlock?.block_num}</p>
          <p>{new Date(currentLiveBlock?.timestamp).toLocaleString()}</p>
          <p>Trans: {currentLiveBlock?.transactions?.length}</p>
        </div>

        <div
          className={`${styles.control_board} ${
            pause ? styles.control_board_paused : ""
          }`}
        >
          {pause ? (
            <button onClick={() => handleToFirstBlock()}>
              <img src={DoubleArrowLeft} alt="first block" />
            </button>
          ) : (
            ""
          )}
          <div className={styles.control_board_middle}>
            <button onClick={() => handlePrevious()}>
              <img src={ArrowLeft} alt="previous" />
            </button>
            {pause ? (
              <button onClick={() => handlePause()}>
                <img src={PlayIcon} alt="play" />
              </button>
            ) : (
              <button
                onClick={() => {
                  handlePause();
                  handleSetPreview();
                }}
              >
                <img src={PauseIcon} alt="pause" />
              </button>
            )}
            <button onClick={() => handleNext()}>
              <img src={ArrowRight} alt="next" />
            </button>
          </div>
          {pause ? (
            <button onClick={() => handleLivePreview()}>
              <img src={DoubleArrowRight} alt="live preview" />
            </button>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default ExplorerWidgetPlayer;
